import React from "react";
import ImageField from "../../ImageField";

export default function LogoSection({ values, onChange }) {

	return <div className="logoSection">
		<div className="details">
			Add your logo. It'll appear on the main page, and as a thumbnail whenever someone posts a link to your shop.
		</div>
		<ImageField
			currentImage={values.logo}
			onChange={logo => onChange({ logo })}
		/>
		<br /><br />
		<div className="details">
			You can also add a banner image. This will appear at the top of your shop page.
		</div>
		<ImageField
			aspectRatio={16 / 9}
			currentImage={values.bannerImage}
			onChange={bannerImage => onChange({ bannerImage })}
		/>
		<br /><br />
	</div>
}
